export const config = {
    apiBaseUrl: "https://vi.sudarshanholiday.com",
}